import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .eleven-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      width: 100%;
    }

    .eleven-media {
      grid-column: 2 / 8;
      grid-row: 2;
      width: 100%;
    }

    .eleven-image img {
      display: block;
      width: 100%;
      height: auto;
      /* Tall images letterbox rather than crop once they hit the cap. */
      max-height: calc(400rem / var(--default-rem-px-count));
      object-fit: contain;
    }

    .eleven-video {
      position: relative;
    }

    .eleven-caption {
      grid-column: 2 / 8;
      grid-row: 3;
      /* Design calls for 20px under the media; the grid already gives 15. */
      margin-top: calc(5rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .eleven-media {
        grid-column: 2 / 14;
      }

      .eleven-image img {
        max-height: calc(700rem / var(--default-rem-px-count));
      }

      .eleven-caption {
        grid-column: 4 / 12;
        /* Row gap is 0 at this breakpoint, so carry the full 20px here. */
        margin-top: calc(20rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      .eleven-media {
        grid-column: 3 / 13;
      }

      .eleven-caption {
        grid-column: 5 / 11;
      }
    }
  `,
];
